<ng-container *ngIf="calendarEvent">
  <mat-icon>{{calendarEvent.icon}}</mat-icon>
  <div class="title">
    {{calendarEvent.title}}
    <!--   {{event.start|date:'HH:mm'}} – {{(event.start + event.duration)|date:'HH:mm'}}-->
  </div>
  <div class="duration">{{calendarEvent.duration|msToString}}</div>
</ng-container>
